import { get } from 'lodash'
import { createSlice } from '@reduxjs/toolkit'
import { DISPOSAL_FEE_ACCOUNTS_TAB_ID } from 'components/pricing/DisposalFeesV2/details/settings'

const initialState = {
  archivedRestoredDisposalFee: undefined,
  createEditDisposalFeeDialog: { isOpen: false, disposalFee: null, configuredServiceId: '' },
  confirmArchiveDisposalFeeDialog: { isOpen: false, disposalFeeId: null },
  confirmDeleteDisposalFeeDialog: { isOpen: false, disposalFeeId: null, accountCount: 0, pricedServiceCount: 0 },
  addPricedServicesDialog: { isOpen: false, disposalFeeId: null },
  removePricedServicesDialog: { isOpen: false, disposalFeeId: null },
  disposalFeeDetailsTab: DISPOSAL_FEE_ACCOUNTS_TAB_ID,
}

const disposalFeesSlice = createSlice({
  name: 'disposalFees',
  initialState: { ...initialState },
  reducers: {
    setArchivedRestoredDisposalFee: (state, action) => {
      state.archivedRestoredDisposalFee = action.payload
    },
    setCreateEditDisposalFeeDialog: (state, action) => {
      state.createEditDisposalFeeDialog = action.payload
    },
    setConfirmArchiveDisposalFeeDialog: (state, action) => {
      state.confirmArchiveDisposalFeeDialog = action.payload
    },
    setConfirmDeleteDisposalFeeDialog: (state, action) => {
      state.confirmDeleteDisposalFeeDialog = action.payload
    },
    setAddPricedServicesDialog: (state, action) => {
      state.addPricedServicesDialog = action.payload
    },
    setRemovePricedServicesDialog: (state, action) => {
      state.removePricedServicesDialog = action.payload
    },
    setDisposalFeeDetailsTab: (state, action) => {
      state.disposalFeeDetailsTab = action.payload
    },
    resetDisposalFeesState: () => {
      return { ...initialState }
    },
  },
})

export const {
  setArchivedRestoredDisposalFee,
  setCreateEditDisposalFeeDialog,
  setConfirmArchiveDisposalFeeDialog,
  setConfirmDeleteDisposalFeeDialog,
  setAddPricedServicesDialog,
  setRemovePricedServicesDialog,
  setDisposalFeeDetailsTab,
  resetDisposalFeesState,
} = disposalFeesSlice.actions

export const selectArchivedRestoredDisposalFee = s => get(s, 'disposalFees.archivedRestoredDisposalFee')
export const selectCreateEditDisposalFeeDialog = s => get(s, 'disposalFees.createEditDisposalFeeDialog')
export const selectConfirmArchiveDisposalFeeDialog = s => get(s, 'disposalFees.confirmArchiveDisposalFeeDialog')
export const selectConfirmDeleteDisposalFeeDialog = s => get(s, 'disposalFees.confirmDeleteDisposalFeeDialog')
export const selectAddPricedServicesDialog = s => get(s, 'disposalFees.addPricedServicesDialog')
export const selectRemovePricedServicesDialog = s => get(s, 'disposalFees.removePricedServicesDialog')
export const selectDisposalFeeDetailsTab = s => get(s, 'disposalFees.disposalFeeDetailsTab')

export default disposalFeesSlice.reducer
